import { render } from "./InternshipCard.vue?vue&type=template&id=7cb38fa3&scoped=true"
import script from "./InternshipCard.vue?vue&type=script&lang=js"
export * from "./InternshipCard.vue?vue&type=script&lang=js"

import "./InternshipCard.vue?vue&type=style&index=0&id=7cb38fa3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb38fa3"]])

export default __exports__